// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"3070f40d","159":"d06bfc6b","262":"bd75ab64","329":"b3454d01","476":"9afb578b","487":"ffdd996e"}[chunkId] + ".chunk.js";
};